<template>
  <div id="app">
    <div v-if="serviceState" class="serviceStateNoticeRect">
      <van-notice-bar
        left-icon="fail"
        :text="serviceState"
        mode="closeable"
      />
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive" />
  </div>
</template>

<script>
import commonData from '@/commondata.js'
import store from '@/store'
import { checkServiceState } from '@/utils/base'
import { NoticeBar } from 'vant'

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {
      serviceState: undefined,
      isRouterAlive: true
    }
  },
  created() {
    if (commonData.enumList === undefined) {
      store.dispatch('user/getEnumList')
    }
    if (commonData.storeBase === undefined) {
      store.dispatch('user/getStoreBase')
    }
    checkServiceState((result) => {
      this.serviceState = result
    })
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>

#app {
   font-family: PingFangSC-Regular, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px;  */
}
.serviceStateNoticeRect{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 10000;
}
</style>
